import React from "react";
import logoDark from "../../assets/icon/Hero-BG (14).png";
import { IoCloseSharp } from "react-icons/io5";
import { menus } from "../../utils/tools/menu";
import MenuAccordion from "./MenuAccordion";
import { removeLocalStorage } from "../../utils/function/localStorage";
import { useGetLoginUserQuery } from "../../Services/userApi";
const Sidebar = ({ sideBarShow, theme }) => {
  const handleLogout = () => {
    removeLocalStorage("grow_boo_token");
    window.location.reload();
  };
  // get user
  const { data } = useGetLoginUserQuery();
  return (
    <div className="ss-trade_sidebar">
      <div className="ss-trade_logo_container">
        {/* <img src={logoDark} width="100%" alt="logo" /> */}
        <h2
          // style={{
          //   padding: "10px",
          //   color: "black",
          //   fontSize: "24px",
          //   fontStyle: "bold",
          //   fontWeight: "bold",
          // }}
          className="logo_text"
        >
          Grow Bizint 
        </h2>
        <IoCloseSharp
          onClick={sideBarShow}
          className="close_icon"
          color="red"
        />
      </div>
      <div className="ss-trade_user_profile">
        <div className="ss-trade_user_info">
          <h2>{data?.data?.name}</h2>
          <p>{data?.data?.email}</p>
        </div>
      </div>
      <div className="ss-trade_sidebar_menu">
        <ul className="ss-trade_sidebar_menu_lists">
          <MenuAccordion
            d={menus}
            sideBarShow={sideBarShow}
            logout={handleLogout}
            userRole={data?.data?.role}
          />
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
